
import React, { useState } from 'react';
import { Filter } from 'lucide-react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { FilterOperation } from '@/hooks/useConnectionData';
import ActiveFiltersList from './filters/ActiveFiltersList';
import NewFilterForm from './filters/NewFilterForm';

interface MultiColumnFilterProps {
  columns: string[];
  dateColumns?: string[];
  activeFilters: Array<{ column: string; value: string; operation: FilterOperation }>;
  onAddFilter: (column: string, value: string, operation: FilterOperation) => void;
  onClearAllFilters: () => void;
  tableData: any[];
}

const MultiColumnFilter: React.FC<MultiColumnFilterProps> = ({
  columns,
  dateColumns,
  activeFilters,
  onAddFilter,
  onClearAllFilters,
  tableData
}) => {
  const [open, setOpen] = useState(false);

  const handleRemoveFilter = (column: string, value: string, operation: FilterOperation) => {
    onAddFilter(column, value, operation);
  };

  return (
    <div data-testid="multi-column-filter">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button 
            variant="outline" 
            size="sm" 
            className="flex items-center gap-1 h-9"
          >
            <Filter size={16} />
            <span>Filter</span>
            {activeFilters.length > 0 && (
              <span className="ml-1 h-5 w-5 rounded-full bg-primary text-xs flex items-center justify-center text-primary-foreground">
                {activeFilters.length}
              </span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="min-w-96 w-max max-w-[95vw] p-5" align="start">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h4 className="font-medium">Filter Data</h4>
            </div>
            
            {/* Current filters */}
            <ActiveFiltersList 
              filters={activeFilters}
              onRemoveFilter={handleRemoveFilter}
              onClearAllFilters={onClearAllFilters}
            />
            
            {/* Add new filter */}
            <NewFilterForm 
              columns={columns}
              dateColumns={dateColumns}
              onAddFilter={onAddFilter}
              tableData={tableData}
            />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default MultiColumnFilter;
